import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取用户表列表 get
 * @param query 分页参数
 * @return request
 * */
export function getUserList(query) {
    return request({
        url: `${baseURL.userApi}/users`,
        method: 'get',
        params: query
    })
}

/**
 * 增加用户表 post
 * @param data 增加的数据
 * @return request
 * */
export function addUser(data) {
    return request({
        url: `${baseURL.userApi}/users`,
        method: 'post',
        data: data
    })
}

/**
 * 删除用户表  delete
 * @param id 用户表id
 * @return request
 * */
export function deleteUser(id) {
    return request({
        url: `${baseURL.userApi}/users/${id}`,
        method: 'delete'
    })
}

/***
 * 修改用户表 Post
 * @param id 要修改的用户表id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateUser(id, data) {
    return request({
        url: `${baseURL.userApi}/users/${id}`,
        method: 'post',
        data: data
    })
}


/**
 * 根据角色KEY查询角色信息
 * @param key
 * @returns {AxiosPromise}
 */
export function getByKey() {
    return request({
        url: `${baseURL.userApi}/roles`,
        method: 'get'
    })
}

/**
 * 管理员重置密码接口
 * @param data
 * @returns {AxiosPromise}
 */
export function resetPassword(data) {
    return request({
        url: `${baseURL.userApi}/users/resetPassword`,
        method: 'post',
        data: data
    })
}
